/**
 * Professional color palette for financial applications
 * Based on Adobe Spectrum Design System
 */

// Main financial colors - Modern vibrant palette for data visualization
export const FINANCIAL_COLORS = [
  '#2563eb', // Vibrant Blue - Investments
  '#3b82f6', // Bright Blue
  '#059669', // Emerald Green - Savings/Growth
  '#10b981', // Bright Green
  '#dc2626', // Bright Red - Warnings/Debt
  '#ef4444', // Coral Red
  '#7c3aed', // Bright Purple - Insurance
  '#8b5cf6', // Vivid Purple
  '#d97706', // Amber Orange - Housing
  '#f59e0b', // Bright Orange
  '#db2777', // Pink - Lifestyle
  '#ec4899', // Hot Pink
  '#374151', // Dark Gray - Neutral
  '#6b7280', // Medium Gray
  '#0d9488', // Teal - Healthcare
  '#14b8a6', // Bright Teal
  '#6366f1', // Indigo - Education
  '#818cf8', // Light Indigo
];

// Chart colors for better visual distinction - Adobe Spectrum
export const CHART_COLORS = {
  primary: '#1473E6',
  secondary: '#9256D9',
  success: '#2D9D78',
  warning: '#E68619',
  danger: '#E34850',
  info: '#1B959A',
  purple: '#9256D9',
  orange: '#E68619',
  teal: '#1B959A',
  blue: '#1473E6',
};

// Color options for goal selection - Modern vibrant financial palette
export const GOAL_COLOR_OPTIONS = [
  { value: '#2563eb', label: 'Investment Blue', hex: '#2563eb' },
  { value: '#059669', label: 'Savings Green', hex: '#059669' },
  { value: '#dc2626', label: 'Alert Red', hex: '#dc2626' },
  { value: '#7c3aed', label: 'Insurance Purple', hex: '#7c3aed' },
  { value: '#d97706', label: 'Housing Orange', hex: '#d97706' },
  { value: '#0d9488', label: 'Healthcare Teal', hex: '#0d9488' },
  { value: '#db2777', label: 'Lifestyle Pink', hex: '#db2777' },
  { value: '#6366f1', label: 'Education Indigo', hex: '#6366f1' },
  { value: '#374151', label: 'Neutral Gray', hex: '#374151' },
  { value: '#f59e0b', label: 'Bright Orange', hex: '#f59e0b' },
];

/**
 * Auto-assign colors to items in a rotating pattern
 * @param {number} index - Index of the item
 * @returns {string} Color hex code
 */
export const getAutoColor = (index) => {
  return FINANCIAL_COLORS[index % FINANCIAL_COLORS.length];
};

/**
 * Get color for value representation (positive/negative)
 * @param {number} value - Numeric value
 * @returns {string} Color for the value
 */
export const getValueColor = (value) => {
  if (value > 0) return CHART_COLORS.success;
  if (value < 0) return CHART_COLORS.danger;
  return '#8C8C8C';
};

/**
 * Get color for status indicators
 * @param {string} status - Status string
 * @returns {string} Color for the status
 */
export const getStatusColor = (status) => {
  const statusColors = {
    'on-track': CHART_COLORS.success,
    'behind': CHART_COLORS.warning,
    'achieved': CHART_COLORS.success,
    'overdue': CHART_COLORS.danger,
    'active': CHART_COLORS.primary,
    'pending': CHART_COLORS.warning,
    'completed': CHART_COLORS.success,
  };

  return statusColors[status] || CHART_COLORS.info;
};
